import { render, staticRenderFns } from "./Erc20AssetList.vue?vue&type=template&id=86f2530a&"
import script from "./Erc20AssetList.vue?vue&type=script&lang=js&"
export * from "./Erc20AssetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports